<template>
    <ui-modal :title="title" :close="() => {}" :no-cancel="true">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="far fa-hourglass"></i>
            </div>
        </template>
        <p
            class="text-sm leading-5 text-gray-500"
            v-for="(paragraph, index) in paragraphs"
            :key="index"
            v-text="paragraph"
        ></p>
        <div class="w-full py-2 px-0 relative mt-2 -ml-2" v-if="useProgress">
            <ui-progress-line :percent="progress+'%'"></ui-progress-line>
        </div>
        <template #footer-primary>
            <ui-button-new danger class="w-full" @click="cancel" v-text="button"></ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import UiProgressLine from "./UiProgressLine.vue";

export default {
    components: {UiProgressLine},
    props: {
        handle: Function,
        close: Function,
        cancel: Function,
        title: {
            type: String,
            default: 'Please wait...'
        },
        progress: 0,
        useProgress: {
            type: Boolean,
            default: false,
        },
        paragraphs: {
            type: Array,
            default: () => [
                'The server is busy processing your request. Please wait...',
            ],
        },
        button: {
            type: String,
            default: 'Cancel'
        },
    },
    data () {
        return {
        }
    },
}
</script>
